import dayjs from 'dayjs';

import { today } from '@constants/utils.constant';

type Options = {
  dateToCompare?: Date | string | null;
  daysToAdd?: number;
};

export function isAfterDate(
  date?: Date | string | number | null,
  options?: Options,
): boolean {
  if (!date) {
    return false;
  }

  const dateToCompareParsed = dayjs(options?.dateToCompare || today).startOf(
    'date',
  );

  const isAfter = dayjs(date)
    .add(options?.daysToAdd || 0, 'day')
    .isAfter(dateToCompareParsed, 'date');

  return isAfter;
}
